import React, { Component } from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { withTranslation } from 'react-i18next';

import { ReactComponent as Google } from './../../assets/img/google.svg';

class FormSelect extends Component{
  constructor(){
    super();
    
    this.state = {
      // focus: false,
    }

    this.checkValue = this.checkValue.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.outFocus = this.outFocus.bind(this);
  }

  componentDidMount(){
    this.checkValue();
  }

  componentDidUpdate(prevProps, prevState){
    if(this.props.value !== prevProps.value){
      this.checkValue();
    }
  }

  componentWillUnmount(){}

  checkValue(){
    if(this.props.value === null){
      this.setState({ focus: false });
    }else{
      this.setState({ focus: true });
    }
  }

  onFocus(){
    this.setState({ focus: true });
  }

  outFocus(){
    this.checkValue();
  }
  
  render(){
    const { options, name, value, valid, placeholder, onChange, className, label, disabled, loading, required, formatOptionLabel, filterOption, asAuto, loadOptions, google, noOptionsMessage, t } = this.props;

    return(
      <>
        <label className={`${this.state.focus ? 'focus' : ''} ${disabled ? 'disabled' : ''}`}>{label} {required ? (<span>*</span>) : ''}</label>
        {asAuto && loadOptions ? (
          <>
            <AsyncSelect
              name={name}
              value={value}
              placeholder={placeholder ? placeholder : ''}
              onChange={onChange}
              onFocus={this.onFocus}
              onBlur={this.outFocus}
              className={`react-select ${className ? className : ''} ${valid === false ? 'error' : ''} as-auto ${google ? 'has-google' : ''}`}
              classNamePrefix="react-select"
              isDisabled={disabled}
              isLoading={loading}
              // options={options}
              defaultOptions
              loadOptions={loadOptions}
              cacheOptions
              menuPortalTarget={typeof document !== 'undefined' ? document.querySelector('body') : ''}
              formatOptionLabel={formatOptionLabel}
              filterOption={filterOption}
              noOptionsMessage={() => {return noOptionsMessage ? noOptionsMessage : 'No options'}}
              loadingMessage={() => {return noOptionsMessage ? noOptionsMessage : 'Loading...'}}
            />
            {google ? (<div className="google">{t('poweredBy')} <Google /></div>) : ''}
          </>
        ) : (
          <Select
            name={name}
            value={value}
            placeholder={placeholder ? placeholder : ''}
            onChange={onChange}
            onFocus={this.onFocus}
            onBlur={this.outFocus}
            className={`react-select ${className ? className : ''} ${valid === false ? 'error' : ''}`}
            classNamePrefix="react-select"
            isDisabled={disabled}
            isLoading={loading}
            options={options}
            menuPortalTarget={typeof document !== 'undefined' ? document.querySelector('body') : ''}
            formatOptionLabel={formatOptionLabel}
            filterOption={filterOption}
          />
        )}
      </>
    );
  }
}

export default withTranslation()(FormSelect);